export default __webpack_public_path__ + "static/media/CNo.69-0.4fd00a23.jpg";